const cargoAbility = (can, cannot) => {
  can('manage', 'Cargo');
};

export default cargoAbility;
